import axios from 'axios';
import {
  SPOR_TOTO_SOCIAL_COUPON_REQUEST,
  SPOR_TOTO_SOCIAL_COUPON_SUCCESS,
  SPOR_TOTO_SOCIAL_COUPON_FAILURE,
} from 'Store/constants';
import { getChannel } from 'Utils/channel';
import errorMessage from 'Store/actions/errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getSporTotoSocialCoupon = externalCouponId => async dispatch => {
  try {
  
    dispatch({
      type: SPOR_TOTO_SOCIAL_COUPON_REQUEST
    });
    
    const res = await axios({
      url: `${API_GATEWAY}/coupon-share/sportoto/coupons/${externalCouponId}`,
      method: 'get',
      headers: {
        channel: getChannel()
      }
    });
  
    dispatch({
      type: SPOR_TOTO_SOCIAL_COUPON_SUCCESS,
      payload: res.data
    });
  
  
  } catch (e) {
  
    dispatch({
      type: SPOR_TOTO_SOCIAL_COUPON_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
  